import { Unit_instance3kz1zqli6gr1r as Unit_instance } from './kotlin/Unit.mjs';
import { isArray1hxjqtqy632bc as isArray } from './kotlin/js/typeCheckUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function arrayConcat(args) {
  var len = args.length;
  // Inline function 'kotlin.js.unsafeCast' call
  var typed = Array(len);
  var inductionVariable = 0;
  var last = len - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var arr = args[i];
      if (!(!(arr == null) ? isArray(arr) : false)) {
        typed[i] = [].slice.call(arr);
      } else {
        typed[i] = arr;
      }
    }
     while (!(i === last));
  return [].concat.apply([], typed);
}
//region block: exports
export {
  arrayConcat as arrayConcat3qsij7vh68m69,
};
//endregion

//# sourceMappingURL=noPackageHacks.mjs.map
